import { yearMemories } from "@/mocks/home";
import SectionHeading from "@/components/feature/SectionHeading";

export default function Years() {
  return (
    <section id="years" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="Timeline"
          title="旧时光的岁月往事"
          description="从麦田到屏幕，几十年被压缩成几个节点。回看时才发现，真正改变我们的，往往不是大事，而是那些当时觉得寻常的傍晚。"
        />

        <div className="mt-10 md:mt-14 relative">
          <span className="hidden md:block absolute left-[9.5rem] top-2 bottom-2 w-px bg-background-300"></span>
          <ol className="flex flex-col gap-6 md:gap-8">
            {yearMemories.map((item) => (
              <li key={item.year} className="relative flex flex-col md:flex-row md:items-stretch gap-3 md:gap-8">
                <div className="md:w-32 shrink-0 flex md:justify-end items-center">
                  <span className="font-heading text-xl md:text-2xl font-bold text-primary-700">
                    {item.year}
                  </span>
                </div>

                <span className="hidden md:flex absolute left-[9.5rem] top-3 -translate-x-1/2 w-4 h-4 items-center justify-center">
                  <span className="w-3 h-3 rounded-full bg-accent-500 ring-4 ring-background-100"></span>
                </span>

                <div className="flex-1 bg-background-50 border border-background-200 rounded-lg p-4 md:p-6">
                  <div className="flex flex-wrap items-center gap-3">
                    <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                      {item.title}
                    </h3>
                    <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-800 text-xs font-label">
                      {item.tag}
                    </span>
                  </div>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">{item.text}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}